export default "__VITE_ASSET__5XB7jCDi__"